import * as angular from "angular";
import { Campaign } from "./models/campaign.model";
import { User } from "./models/user.model";
import { NavigationBarHelperService } from "./components/navigation/navigation-bar.helper";
import { CredentialsManager } from "./shared/credentials-manager";
import { UserDataProvider } from "./data-provider/user.dp";
import { ScreenUtils } from "./helper/screen.helper";
import { ApiUserService } from "./services/user.service";

let env = {};
//Import variables if present (from env.js)
if (window) {
    angular.extend(env, window["__env"]);
}
let app = angular.module("adminApp", [
    "adminDependencies",
    "angular-json-tree",
]);

app.config([
    "$locationProvider",
    ($locationProvider: any) => {
        $locationProvider.hashPrefix("");
    },
]);

app.config(($httpProvider: any) => {
    $httpProvider.defaults.withCredentials = true;
});

angular["lowercase"] = angular["$$lowercase"];

app.config([
    "$qProvider",
    ($qProvider: any) => {
        $qProvider.errorOnUnhandledRejections(false);
    },
]);

// Register environment in AngularJS as constant
app.constant("__env", env);

app.constant("__app_type", "ADMIN");

app.constant("__time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone);

app.config(($httpProvider: any) => {
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push("httpRequestInterceptor");
});

app.config([
    "$routeProvider",
    ($routeProvider: any) => {
        $routeProvider
            .when("/admin_users", {
                reloadOnSearch: false,
                template:
                    '<vc-admin-users flex class="layout-column"></vc-admin-users>',
            })
            .when("/admin_campaigns", {
                reloadOnSearch: false,
                template:
                    '<vc-admin-campaigns flex class="layout-column"></vc-admin-campaigns>',
            })
            .when("/admin_organisations", {
                reloadOnSearch: false,
                template:
                    '<vc-admin-organisations flex class="layout-column"></vc-admin-organisations>',
            })
            .when("/admin_logins", {
                reloadOnSearch: false,
                template:
                    '<vc-admin-logins flex class="layout-column"></vc-admin-logins>',
            })
            .when("/admin_live", {
                reloadOnSearch: false,
                template:
                    '<vc-admin-live flex class="layout-column"></vc-admin-live>',
            });
    },
]).run(
    (
        $rootScope: any,
        $location: any,
        NavigationBarHelperService: NavigationBarHelperService
    ) => {
        $rootScope.$on("$routeChangeSuccess", (event: any) => {
            NavigationBarHelperService.setSelectedSideBarItem($location.path());
        });
    }
);

export class AdminRootController {
    private readonly $scope: any;
    private readonly $cookies: any;
    private readonly $window: any;
    private credentialsManager: CredentialsManager;
    private userDataProvider: UserDataProvider;
    private readonly modelsUtils: any;
    public readonly navigationBarService: NavigationBarHelperService;
    public readonly __env: any;
    public readonly screen: ScreenUtils;
    public readonly localStorageService: any;

    private readonly $location: any;
    public uid: string | number;
    public access_token: string;
    public user: User;
    public activeCampaign: Campaign;
    private readonly apiUserService: ApiUserService;

    constructor(
        $scope: any,
        $cookies: any,
        $window: any,
        $location: any,
        CredentialsManager: CredentialsManager,
        UserDataProvider: UserDataProvider,
        ModelsUtils: any,
        NavigationBarHelperService: NavigationBarHelperService,
        __env: any,
        ScreenUtils: ScreenUtils,
        localStorageService: any,
        ApiUserService: ApiUserService
    ) {
        this.$scope = $scope;
        this.$cookies = $cookies;
        this.$window = $window;
        this.$location = $location;
        this.credentialsManager = CredentialsManager;
        this.userDataProvider = UserDataProvider;
        this.modelsUtils = ModelsUtils;
        this.navigationBarService = NavigationBarHelperService;
        this.__env = __env;
        this.screen = ScreenUtils;
        this.localStorageService = localStorageService;
        this.apiUserService = ApiUserService;
        this.uid = this.$cookies.get("uid");
        this.access_token = this.credentialsManager.getAccessToken();
        this.user = this.modelsUtils.user({
            uid: this.$cookies.get("uid"),
            ufname: this.$cookies.get("ufname"),
            ulname: this.$cookies.get("ulname"),
            uemail: this.$cookies.get("uemail"),
        });
        this.userDataProvider.setActiveUser(this.user);
        this.navigationBarService.setAutoSidebar(true);
        this.__env = __env;
        this.activeCampaign = this.$cookies.getObject("campaign");

        for (let property in this.activeCampaign) {
            if (this.activeCampaign.hasOwnProperty(property)) {
                this.activeCampaign[property] = decodeURIComponent(
                    this.activeCampaign[property]
                );
            }
        }
        this.credentialsManager.setCredentials(
            this.activeCampaign.campaignid,
            this.access_token,
            null,
            false,
            this.$cookies.get("uid")
        );
    }

    // ---------- who is signed in (sidebar foot) ----------

    private cookieText(name: string): string {
        const value = this.$cookies.get(name);
        if (!value) return "";
        try {
            // PHP's setcookie() percent-encodes (a space is %20, a plus is
            // %2B), so a literal "+" is real - as in dev+alias@example.com.
            return decodeURIComponent(String(value));
        } catch (e) {
            return String(value);
        }
    }

    signedInName(): string {
        const name = [this.cookieText("ufname"), this.cookieText("ulname")]
            .filter(Boolean)
            .join(" ");
        return name || this.signedInEmail() || "Signed in";
    }

    signedInEmail(): string {
        return this.cookieText("uemail");
    }

    signedInInitials(): string {
        const parts = [this.cookieText("ufname"), this.cookieText("ulname")]
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase());
        if (parts.length) return parts.join("").slice(0, 2);
        const email = this.signedInEmail();
        return email ? email.charAt(0).toUpperCase() : "?";
    }

    checkIsActive(): void {
        this.apiUserService.is_active({ type: 1 }).then(
            (response: object) => {},
            () => {
                window.location.href = "/logout.php?r=" + this.$location.url();
            }
        );
    }
}

app.controller("AdminRootController", AdminRootController);
